import React from 'react';
import classNames from 'classnames';
import { Icon, IconColor, IconName } from 'app/common/components/controls';
import { featureFlagClient } from '@trello/feature-flag-client';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Button } from '@trello/nachos';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';

import styles from './channel-switcher.less';

const format = forTemplate('header_channel_picker');

export class FeatureFlagList extends React.Component {
  state = {
    flags: featureFlagClient.all(),
  };

  componentDidMount() {
    featureFlagClient.client.on('change', this.onFlagChange);
  }

  componentWillUnmount() {
    featureFlagClient.client.off('change', this.onFlagChange);
  }

  onFlagChange = () => {
    this.setState({ flags: featureFlagClient.all() });
  };

  flagToggleHandler = (key: string, value: boolean) => {
    featureFlagClient.setOverride(key, value);
    this.onFlagChange();
  };

  resetOverridesHandler = () => {
    featureFlagClient.resetOverrides();
    this.onFlagChange();
  };

  render() {
    const { flags } = this.state;

    return (
      <div>
        <p>{format('listed-below-are-feature-flags')}</p>
        <Button
          appearance="danger"
          onClick={this.resetOverridesHandler}
          shouldFitContainer
        >
          {format('reset-all-feature-flags')}
        </Button>
        <PopoverMenu className={styles.popoverMenu}>
          {Object.entries({ ...flags.remote, ...flags.overrides })
            .filter(([, value]) => typeof value === 'boolean')
            .sort()
            .map(([key, value]) => {
              const hasOverride = flags.overrides[key] !== undefined;

              return (
                <PopoverMenuButton
                  key={key}
                  className={classNames(
                    styles.featureFlagMenuButton,
                    (value || hasOverride) && styles.featureFlagSelected,
                  )}
                  onClick={() => this.flagToggleHandler(key, !value)}
                >
                  {value && (
                    <Icon
                      small
                      name={IconName.Check}
                      color={hasOverride ? IconColor.Green : IconColor.Gray}
                    />
                  )}
                  {flags.overrides[key] === false && (
                    <Icon small name={IconName.Close} color={IconColor.Red} />
                  )}
                  {key}
                </PopoverMenuButton>
              );
            })}
        </PopoverMenu>
      </div>
    );
  }
}
